type Props = {
  fill: string;
  opacity: string;
  className?: any;
};

const HintIcon = ({ fill, opacity, className }: Props) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Hint</title>
    <g id="Find-It-Letters" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Large---A-Z-Letter---Find-It---Find-It-Letters----Initial"
        transform="translate(-1191.000000, -710.000000)"
      >
        <g id="hint_button" transform="translate(1181.000000, 700.000000)">
          <g
            id="01.-Atoms/01.-Iconography/06.-XXX-Large/Black-Copy-5"
            transform="translate(10.000000, 10.000000)"
          >
            <rect id="Rectangle" x="2" y="2.3255814" width="20" height="20"></rect>
            <path
              d="M15.7556019,18.0004649 C15.7574787,17.9882884 15.7588978,17.9765697 15.7607746,17.9639355 C16.2224739,16.4067187 17.4337137,14.5607911 18.2081107,13.6772178 C19.4788596,12.2273464 20.2499607,10.3298747 20.2499607,8.2500304 C20.2499607,3.68490151 16.5426331,-0.0140032433 11.9742083,1.01554162e-05 C7.19251193,0.0145611417 3.75,3.88924673 3.75,8.2500304 C3.75,10.3298747 4.52110107,12.2273464 5.79184999,13.6772178 C6.56624695,14.5607911 7.77748674,16.4067187 8.23918607,17.9639355 C8.2410629,17.9761119 8.24248196,17.9882884 8.24435879,18.0004649 L15.7556019,18.0004649 Z M12.4462073,10.500025 L11.5537534,10.500025 C11.1684088,10.500025 10.8459151,10.2079725 10.807463,9.82455057 L10.2074736,3.82456488 C10.1634369,3.38300709 10.5098258,3.00004292 10.9537182,3.00004292 L13.0462425,3.00004292 C13.4901349,3.00004292 13.8365238,3.38300709 13.792487,3.82456488 L13.1924976,9.82455057 C13.1540456,10.2079725 12.8315518,10.500025 12.4462073,10.500025 Z M11.9999839,15.0000215 C11.1717047,15.0000215 10.4999839,14.3282935 10.4999839,13.5000215 C10.4999839,12.6717423 11.1717047,12.0000215 11.9999839,12.0000215 C12.8282559,12.0000215 13.4999839,12.6717423 13.4999839,13.5000215 C13.4999839,14.3282935 12.8282559,15.0000215 11.9999839,15.0000215 Z M13.4465559,24.0004506 C13.8902194,24.0004506 14.449651,23.7005703 14.6952864,23.3311102 L15.4963709,22.1268741 C15.6347983,21.9189584 15.7473621,21.5474383 15.7476368,21.2976372 L15.7495136,19.5000036 L8.25044703,19.5000036 L8.25278162,21.2976372 C8.25328516,21.5924821 8.34044316,21.8812387 8.5040475,22.1268741 L9.30513202,23.3311102 C9.55076742,23.7005703 10.1101991,24.0004506 10.5539083,24.0004506 L13.4465559,24.0004506 Z"
              id="hint-icon"
              fillRule="nonzero"
              style={{ fill: fill || '#333', opacity: opacity }}
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

HintIcon.defaultProps = {
  fillHint: 'transparent',
  fill: '#d5d5d5',
  opacity: '1',
};

export default HintIcon;
